import { clusterCondition, advanceConditions } from '../object-templates/components/helpers/condition-builder-helper';
import { fromModel } from '/src/common/components/rule-builder/rule-builder-service.js';

export const checkIfStepHidden = (currentPhases, record, fieldDetails, activePhaseAndStep) => {
  const phases = JSON.parse(JSON.stringify(currentPhases));

  for (let phase = 0; phase < phases.length; phase++) {
    const phaseDetails = phases[phase];
    const { phaseRecord, fieldsMap } = getRecordAndFieldsForPhase(phaseDetails, record, fieldDetails);
    let isPhaseHidden = false;
    if (evaluatePhaseCondition({ phase, phaseDetails }, fieldsMap, phaseRecord, activePhaseAndStep)) {
      let conditions = getCondition(phaseDetails);
      isPhaseHidden = evaluateCondition(fieldsMap, phaseRecord, conditions, phaseDetails.ShowPhaseConditionally);
    }
    phaseDetails['isPhaseHidden'] = isPhaseHidden;
    if (phaseDetails['isPhaseHidden']) continue;
    for (let step = 0; step < phases[phase].Steps.length; step++) {
      let isStepHidden;
      let stepDetails = phaseDetails.Steps[step];
      if (phase === activePhaseAndStep?.activePhase && step === activePhaseAndStep?.activeStep) {
        isStepHidden = false;
      } else if (evaluateStepCondition({ stepDetails }, fieldsMap, phaseRecord)) {
        let conditions = getCondition(stepDetails);
        isStepHidden = evaluateCondition(fieldsMap, phaseRecord, conditions, stepDetails.ShowStepConditionally);
      } else {
        isStepHidden = false;
      }
      stepDetails['isStepHidden'] = isStepHidden;
    }
  }
  return phases;
};

const conditionEvaluator = (condition, record) =>
  new Function(`return ${condition}`).bind({
    modifiedRecord: record,
    advanceConditions: advanceConditions,
    elementValues: {}
  })();

const evaluateCondition = (fieldsMap, phaseRecord, conditions, isEntityToBeShown) =>
  isEntityToBeShown
    ? !conditionEvaluator(clusterCondition(conditions, fieldsMap), phaseRecord)
    : conditionEvaluator(clusterCondition(conditions, fieldsMap), phaseRecord);

const evaluatePhaseCondition = ({ phase, phaseDetails }, fieldsMap, phaseRecord, activePhaseAndStep) =>
  (phaseDetails.ShowPhaseConditionally || phaseDetails.HidePhaseConditionally) &&
  fieldsMap &&
  phaseRecord &&
  phase !== activePhaseAndStep?.activePhase;

const evaluateStepCondition = ({ stepDetails }, fieldsMap, phaseRecord) =>
  (stepDetails.ShowStepConditionally || stepDetails.HideStepConditionally) && fieldsMap && phaseRecord;

const getCondition = (details) =>
  fromModel(
    JSON.parse(details.hideCondition).group,
    { key: 'field', operator: 'condition', value: 'data1' },
    'operator'
  );

const getRecordAndFieldsForPhase = (phaseDetails, record, fieldDetails) => {
  const phaseRecord = phaseDetails.PhaseObjectUUID ? record?.[setRecordKeyValue(phaseDetails)] : record;
  const fieldsForPhase = phaseDetails.PhaseObjectUUID ? fieldDetails?.[phaseDetails.PhaseObjectUUID] : fieldDetails;
  const fieldsMap =
    fieldsForPhase && fieldsForPhase.reduce((obj, field) => Object.assign(obj, { [field.Name]: field }), {});
  return { phaseRecord, fieldsMap };
};

export const getNextActivePhaseAndStep = (phases, currentPhaseAndStep = { currentPhase: 0, currentStep: 0 }) => {
  let { currentPhase, currentStep } = currentPhaseAndStep;
  for (let phase = currentPhase; phase < phases.length; phase++) {
    if (phases[phase].isPhaseHidden) {
      continue;
    }
    if (phase !== currentPhase) {
      currentStep = 0;
    }
    for (let step = currentStep; step < phases[phase].Steps.length; step++) {
      if (!phases[phase].Steps[step]?.isStepHidden) {
        return { phase, step };
      }
    }
  }
  return null;
};

export const getPreviousPhaseAndStep = (phases, currentPhaseAndStep = { currentPhase: 0, currentStep: 0 }) => {
  let { currentPhase, currentStep } = currentPhaseAndStep;
  for (let phase = currentPhase; phase >= 0; phase--) {
    if (phases[phase].isPhaseHidden) {
      continue;
    }
    if (phase !== currentPhase) {
      currentStep = phases[phase].Steps.length - 1;
    }
    for (let step = currentStep; step >= 0; step--) {
      if (!phases[phase].Steps[step]?.isStepHidden) {
        return { phase, step };
      }
    }
  }
  return null;
};

export const isWizardTypeMultiple = (wizardDetails) => wizardDetails.WizardType === 'multiple';

export const setRecordKeyValue = (currentPhaseDetails) =>
  `${currentPhaseDetails.BaseObjField}-${currentPhaseDetails.CurrentObjField}-${currentPhaseDetails.PhaseObjectUUID}`;
